import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ParametrosService } from './services/parametros.service';
import { UserService } from './services/user.service';
import { UtmTrackingService } from './services/utm-tracking.service';
import { CookieConsentOrchestratorService } from './shared/cookie-consent/cookie-consent-orchestrator.service';
//JQuery
declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  mensajeModal = '';
  timedOut = false;
  lastPing?: Date;
  idInterval: any = null;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private router: Router,
    private _user: UserService,
    private _parametro: ParametrosService,
    private readonly utmTracking: UtmTrackingService,
    private readonly cookieConsentOrchestrator: CookieConsentOrchestratorService
  ) {
    //Tiempo de inactividad en segundos para que salga el modal
    idle.setIdle(60 * 14);
    // Tiempo de espera en el modal
    idle.setTimeout(60);
    // Determina los movimientos de actividad
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.mensajeModal = 'Vuelves a estar activo.';
      this.reset();
      //$('#inactivoModal').modal('hide');
    });

    idle.onTimeout.subscribe(async () => {
      this.mensajeModal = 'Te hemos desconectado por inactividad.';
      this.timedOut = true;
      this.utmTracking.registrarFinalizacionSesion();
      await this._user.deleteUser();
      this.router.navigateByUrl('/home');
    });

    idle.onIdleStart.subscribe(() => {
      this.mensajeModal = 'Te has quedado inactivo.';
      $('#inactivoModal').modal('show');
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.mensajeModal =
        'El tiempo de inactividad disponible es: ' + countdown + ' segundos.';
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this._user.isUserLogIn().subscribe((userLoggedIn) => {
      if (userLoggedIn) {
        idle.watch();
        this.timedOut = false;
        this.idInterval = setInterval(
          this.refreshToken,
          45 * 60 * 1000,
          _user,
          _parametro
        );
      } else {
        idle.stop();
        if (this.idInterval) {
          clearInterval(this.idInterval);
        }
      }
    });

    //Cuando se recarga la página
    if (this._user.getUser()) {
      idle.watch();
      this.timedOut = false;
    } else {
      idle.stop();
    }

  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.utmTracking.capturarDesdeUrlActual();
      });
  }

  refreshToken(_user: UserService, _parametro: ParametrosService) {
    let isEmpresario = _user.getUser().actor === 'microempresario';
    _parametro
      .refreshToken(_user.getToken(), isEmpresario)
      .subscribe((data: any) => {
        if (data.exitoso) {
          _user.setToken(data.token);
        }
      });
  }

  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  hideChildModal(): void {
    $('#inactivoModal').modal('hide');
  }

  stay() {
    $('#inactivoModal').modal('hide');
    this.reset();
  }

  async logOut() {
    $('#inactivoModal').modal('hide');
    this.utmTracking.registrarFinalizacionSesion();
    await this._user.deleteUser();
    this.router.navigateByUrl('/home');
  }
}
